export const QUESTION_STATUS_ACTIVE = 'ACTIVE';
export const QUESTION_STATUS_ARCHIVED = 'ARCHIVED';
export const QUESTION_STATUS_UNDER_REVIEW = 'UNDER_REVIEW';
export const QUESTION_STATUS_MAP = {
  [QUESTION_STATUS_ACTIVE]: 'Active',
  [QUESTION_STATUS_ARCHIVED]: 'Archived',
  [QUESTION_STATUS_UNDER_REVIEW]: 'Under Review',
};

export const QUESTION_STATUS_COLOR_MAP = {
  [QUESTION_STATUS_ACTIVE]: 'green',
  [QUESTION_STATUS_ARCHIVED]: 'grey',
  [QUESTION_STATUS_UNDER_REVIEW]: 'yellow',
};

export const BULK_OPERATION_ACTIVATE = 'activate';
export const BULK_OPERATION_ARCHIVE = 'archive';
export const BULK_OPERATION_ASSIGN_GROUPS = 'assign_groups';
export const BULK_OPERATION_DELETE = 'delete';

export const BULK_OPERATIONS = [
  {
    key: BULK_OPERATION_ACTIVATE,
    text: 'Activate',
    value: BULK_OPERATION_ACTIVATE,
    icon: 'checkmark',
  },
  {
    key: BULK_OPERATION_ARCHIVE,
    text: 'Archive',
    value: BULK_OPERATION_ARCHIVE,
    icon: 'archive',
  },
  {
    key: BULK_OPERATION_ASSIGN_GROUPS,
    text: 'Assign to Groups',
    value: BULK_OPERATION_ASSIGN_GROUPS,
    icon: 'tags',
  },
  {
    key: BULK_OPERATION_DELETE,
    text: 'Delete',
    value: BULK_OPERATION_DELETE,
    icon: 'trash',
    color: 'red',
  },
];

export const QUESTION_STATUS_OPTIONS = [
  {
    key: QUESTION_STATUS_ACTIVE,
    text: QUESTION_STATUS_MAP[QUESTION_STATUS_ACTIVE],
    value: QUESTION_STATUS_ACTIVE,
  },
  {
    key: QUESTION_STATUS_ARCHIVED,
    text: QUESTION_STATUS_MAP[QUESTION_STATUS_ARCHIVED],
    value: QUESTION_STATUS_ARCHIVED,
  },
  {
    key: QUESTION_STATUS_UNDER_REVIEW,
    text: QUESTION_STATUS_MAP[QUESTION_STATUS_UNDER_REVIEW],
    value: QUESTION_STATUS_UNDER_REVIEW,
  },
];

export const DEFAULT_QUESTION_DATA = {
  text: '',
  status: QUESTION_STATUS_ACTIVE,
  groups: [],
  answers: [
    {
      text: '',
      isPreferred: true,
    },
  ],
};

export const ANSWER_VALIDATION = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 1000,
  MIN_ANSWERS: 1,
  MAX_ANSWERS: 10,
};

export const QUESTION_VALIDATION = {
  MIN_LENGTH: 5,
  MAX_LENGTH: 500,
};
